import z from "zod";
import { ROUNDING_BEHAVIOR } from "@miplatform/constants";

export const priceLevelSchema = z.object({
  name: z.string().min(1, "Name is required"),
  percentAdjustment: z.number().optional(),
  roundingBehavior: z.nativeEnum(ROUNDING_BEHAVIOR).optional(),
  displayOrder: z.number().optional(),
  dropPrices: z.array(
    z.object({
      priceLevelId: z.string().optional(),
      dropTypeId: z.string().optional(),
      categoryId: z.string().optional(),
      price: z.number().optional(),
    })
  ),
});
